import React from 'react'
import './modal.css'

import { Modal, Typography, Button } from 'material-ui'
import Loading from './Loading'

const DeleteModal = props => (
  <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={props.open}
    onClose={props.onClose}
  >
    <div className="modalZero">
      <Typography variant="body1" id="modal-title">
        Are you sure to delete this?
      </Typography>
      <br />
      {props.loading ? (
        <Loading />
      ) : (
        <Button onClick={props.yes} className="icon" size="small">
          Yes
        </Button>
      )}
      <Button onClick={props.onClose} className="icon" size="small">
        No
      </Button>
    </div>
  </Modal>
)

export default DeleteModal



// WEBPACK FOOTER //
// ./src/components/modals/Delete.js